export function navigateToURL(url, target) {
    window.open(url.url, "_blank");
}
